import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import axios from 'axios';
import { Calendar, Plus, MessageSquare, Copy, Eye, Clock, AlertCircle, CheckCircle, XCircle } from 'lucide-react';
import RaiseTicketModal from '../components/RaiseTicket';
import ChatModal from '../components/ChatModal';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { useLocation, useNavigate } from 'react-router-dom';


const UserTickets = () => {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isRaiseTicketOpen, setIsRaiseTicketOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState({
    unreadCount: 0,
    unreadTickets: []
});
const [ticketCounts, setTicketCounts] = useState({
    pending: 0,
    inProgress: 0,
    resolved: 0,
    closed: 0,
    all:0
});

const [pagination, setPagination] = useState({
    page: 1,
    limit: 50, // Change this from 50 to 5
    total: 0,
    pages: 0
});

 const API_BASE_URL = 'https://ufb-1.onrender.com/ticket';


    const [filters, setFilters] = useState({
        dateFrom: '',
        dateTo: '',
        orderId: '',
        awb: '',
        status: '',
        category: ''
    });
    const [showFilters, setShowFilters] = useState(false);
    const [chatModal, setChatModal] = useState({
    isOpen: false,
    ticket: null,
    isViewOnly: false
});

    const user = auth.currentUser;

    const statusColors = {
        'pending': 'bg-orange-100 text-orange-800',
        'in-progress': 'bg-blue-100 text-blue-800',
        'resolved': 'bg-green-100 text-green-800',
         'all': 'bg-gray-100 text-gray-800',
        // 'closed': 'bg-gray-100 text-gray-800'
    };

    const categories = [
        'Order Issue',
        'Shipping Problem',
        'Product Quality',
        'Payment Issue',
        'Refund Request',
        'Technical Support',
        'Other'
    ];

    const fetchTicketCounts = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/user-tickets/${user.uid}/counts`);
        if (response.data.success) {
            const counts = response.data.data;
            setTicketCounts({
                pending: counts.pending || 0,
                inProgress: counts['in-progress'] || 0,
                resolved: counts.resolved || 0,
                closed: counts.closed || 0,
                all: counts.all || 0
            });
        }
    } catch (error) {
        console.error('Error fetching ticket counts:', error);
    }
};

useEffect(() => {
    if (user) {
        fetchUserTickets();
        fetchTicketCounts(); // Add this
        fetchNotifications();
        const interval = setInterval(fetchNotifications, 30000);
        return () => clearInterval(interval);
    }
}, [user]);


    const fetchNotifications = async () => {
    if (!user) return;
    try {
        const response = await axios.get(`${API_BASE_URL}/api/user-notifications/${user.uid}`);
        if (response.data.success) {
            setNotifications(response.data.data);
        }
    } catch (error) {
        console.error('Error fetching notifications:', error);
    }
};

 useEffect(() => {
    if (user) {
        fetchUserTickets();
        fetchNotifications();
        fetchTicketCounts();
        // Poll for notifications every 30 seconds
        const interval = setInterval(fetchNotifications, 30000);
        return () => clearInterval(interval);
    }
}, [user, pagination.page, filters]);

    // const fetchUserTickets = async () => {
    //     try {
    //         setLoading(true);
    //         const response = await axios.get(`http://localhost:8080/ticket/api/user-tickets/${user.uid}`, {
    //             params: filters,
    //             page: pagination.page,
    //             limit: pagination.limit
    //         });
            
    //         if (response.data.success) {
    //             setTickets(response.data.data);
    //             setPagination(prev => ({
    //     ...prev,
    //     total: response.data.pagination.total,
    //     pages: response.data.pagination.pages
    // }));
    //         }
    //     } catch (error) {
    //         console.error('Error fetching tickets:', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    const fetchUserTickets = async () => {
    try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/api/user-tickets/${user.uid}`, {
            params: {
                ...filters,
                page: pagination.page,
                limit: pagination.limit
            }
        });
        
        if (response.data.success) {
            setTickets(response.data.data);
            setPagination(prev => ({
                ...prev,
                total: response.data.pagination.total,
                pages: response.data.pagination.pages
            }));
        }
    } catch (error) {
        console.error('Error fetching tickets:', error);
    } finally {
        setLoading(false);
    }
};


    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const applyFilters = () => {
        setPagination(prev => ({ ...prev, page: 1 })); // Reset to first page
        fetchUserTickets();
    };

    const clearFilters = () => {
        setFilters({
            dateFrom: '',
            dateTo: '',
            orderId: '',
            awb: '',
            status: '',
            category: ''
        });
         setPagination(prev => ({ ...prev, page: 1 })); // Reset to first page
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        // You can add a toast notification here
    };


    useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const typeParam = urlParams.get('type');
    
    if (typeParam && ['pending', 'in-progress', 'resolved', 'closed', 'all'].includes(typeParam)) {
        setFilters(prev => ({
            ...prev,
            status: typeParam
        }));
    } else if (!typeParam) {
        // Default to pending if no type specified
        setFilters(prev => ({
            ...prev,
            status: 'pending'
        }));
    }
}, [location.search]);


const handleStatusCardClick = (status) => {
    const newFilters = { ...filters, status };
    setFilters(newFilters);
    setPagination(prev => ({ ...prev, page: 1 })); // Reset to first page
    
    // Update URL
    const searchParams = new URLSearchParams();
    if (status && status !== 'all') {
        searchParams.set('type', status);
    }
    navigate(`/tickets?${searchParams.toString()}`, { replace: true });
    
    // Fetch tickets immediately with reset pagination
    fetchUserTicketsWithStatusAndResetPage(status);
};

const fetchUserTicketsWithStatusAndResetPage = async (status = null) => {
    try {
        setLoading(true);
        const filterParams = {
            ...filters,
            status: status || filters.status
        };
        
        // Reset pagination to first page
        const newPagination = { ...pagination, page: 1 };
        setPagination(newPagination);
        
        const response = await axios.get(`${API_BASE_URL}/api/user-tickets/${user.uid}`, {
            params: {
                ...filterParams,
                page: 1, // Always start from page 1 when changing filters
                limit: pagination.limit
            }
        });
        
        if (response.data.success) {
            setTickets(response.data.data);
            setPagination(prev => ({
                ...prev,
                page: 1,
                total: response.data.pagination.total,
                pages: response.data.pagination.pages
            }));
        }
    } catch (error) {
        console.error('Error fetching tickets:', error);
    } finally {
        setLoading(false);
    }
};

const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
    // fetchUserTickets will be called by useEffect when pagination.page changes
};


const fetchUserTicketsWithStatus = async (status = null) => {
    try {
        setLoading(true);
        const filterParams = {
            ...filters,
            status: status || filters.status
        };
        
        const response = await axios.get(`${API_BASE_URL}/api/user-tickets/${user.uid}`, {
            params: {
                ...filterParams,
                page: pagination.page,
                limit: pagination.limit
            }
        });
        
        if (response.data.success) {
            setTickets(response.data.data);
            setPagination(prev => ({
                ...prev,
                total: response.data.pagination.total,
                pages: response.data.pagination.pages
            }));
        }
    } catch (error) {
        console.error('Error fetching tickets:', error);
    } finally {
        setLoading(false);
    }
};


const formatDate = (input) => {
  if (!input) return 'N/A';

  let date;

  if (typeof input.toDate === 'function') {
    // Firestore Timestamp
    date = input.toDate();
  } else {
    // ISO string, millis, or Date
    date = new Date(input);
  }

  if (isNaN(date)) return 'N/A';

  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).replace(',', ''); // → "18 Aug 2025 05:00 PM"
};



    const getDefaultDateRange = () => {
        const today = new Date();
        const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        
        return {
            from: lastMonth.toISOString().split('T')[0],
            to: today.toISOString().split('T')[0]
        };
    };

    // Set default date range on component mount
    useEffect(() => {
        const defaultRange = getDefaultDateRange();
        setFilters(prev => ({
            ...prev,
            dateFrom: defaultRange.from,
            dateTo: defaultRange.to
        }));
    }, []);

    if (!user) {
        return (
            <div className="flex items-center justify-center h-64">
                <p className="text-gray-500">Please log in to view your tickets.</p>
            </div>
        );
    }

    const openChatModal = async (ticket, isViewOnly = false) => {
    setChatModal({
        isOpen: true,
        ticket,
        isViewOnly
    });
    
    // Mark as read when user opens chat
    if (notifications.unreadTickets.includes(ticket.ticketId)) {
        try {
            await axios.put(`${API_BASE_URL}/api/tickets/${ticket.ticketId}/user-read`);
            fetchNotifications(); // Refresh notifications
        } catch (error) {
            console.error('Error marking as read:', error);
        }
    }
};


// Add this to calculate ticket counts
// const ticketCounts = {
//     pending: tickets.filter(t => t.status === 'pending').length,
//     inProgress: tickets.filter(t => t.status === 'in-progress').length,
//     resolved: tickets.filter(t => t.status === 'resolved').length,
//     closed: tickets.filter(t => t.status === 'closed').length
// };

return (
   <div className="flex h-screen bg-gray-50">
  {/* Sidebar */}
  <Sidebar />

  {/* Main content */}
  <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
    <Header />

    <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
                {/* Header */}
                <div className="flex items-center justify-between mb-6 flex-shrink-0">
                    {/* <div>
                        <h1 className="text-2xl font-bold text-gray-900">Support Tickets</h1>
                        <p className="text-gray-600 mt-1">Track and manage your support requests</p>
                    </div> */}
                    <button
                        onClick={() => setIsRaiseTicketOpen(true)}
                        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <Plus className="w-4 h-4 mr-2" />
                        Raise Ticket
                    </button>
                </div>

                {/* Status Cards */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 flex-shrink-0">
                    <div 
                         onClick={() => handleStatusCardClick('pending')}
                        className={`bg-white rounded-lg shadow-sm border p-4 cursor-pointer hover:shadow-md transition-shadow ${filters.status === 'pending' ? 'ring-2 ring-orange-500 border-orange-200' : ''}`}
                    >
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                                    <Clock className="w-5 h-5 text-orange-600" />
                                </div>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-gray-900">Pending</p>
                                <p className="text-2xl font-bold text-gray-900">{ticketCounts.pending || 0}</p>
                            </div>
                        </div>
                    </div>

                    <div 
                        onClick={() => handleStatusCardClick('in-progress')}
                        className={`bg-white rounded-lg shadow-sm border p-4 cursor-pointer hover:shadow-md transition-shadow ${filters.status === 'in-progress' ? 'ring-2 ring-blue-500 border-blue-200' : ''}`}
                    >
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                    <AlertCircle className="w-5 h-5 text-blue-600" />
                                </div>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-gray-900">In Progress</p>
                                <p className="text-2xl font-bold text-gray-900">{ticketCounts.inProgress || 0}</p>
                            </div>
                        </div>
                    </div>

                    <div 
                        onClick={() => handleStatusCardClick('resolved')}
                        className={`bg-white rounded-lg shadow-sm border p-4 cursor-pointer hover:shadow-md transition-shadow ${filters.status === 'resolved' ? 'ring-2 ring-green-500 border-green-200' : ''}`}
                    >
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                                    <CheckCircle className="w-5 h-5 text-green-600" />
                                </div>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-gray-900">Resolved</p>
                                <p className="text-2xl font-bold text-gray-900">{ticketCounts.resolved || 0}</p>
                            </div>
                        </div>
                    </div>

                    {/* <div 
                        onClick={() => handleStatusCardClick('closed')}
                        className={`bg-white rounded-lg shadow-sm border p-4 cursor-pointer hover:shadow-md transition-shadow ${filters.status === 'closed' ? 'ring-2 ring-gray-500 border-gray-200' : ''}`}
                    >
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                                    <XCircle className="w-5 h-5 text-gray-600" />
                                </div>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-gray-900">Closed</p>
                                <p className="text-2xl font-bold text-gray-900">{ticketCounts.closed || 0}</p>
                            </div>
                        </div>
                    </div>
                </div> */}

                  <div 
                        onClick={() => handleStatusCardClick('all')}
                        className={`bg-white rounded-lg shadow-sm border p-4 cursor-pointer hover:shadow-md transition-shadow ${filters.status === 'all' ? 'ring-2 ring-gray-500 border-gray-200' : ''}`}
                    >
                        <div className="flex items-center">
                            <div className="flex-shrink-0">
                                <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                                    <XCircle className="w-5 h-5 text-gray-600" />
                                </div>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-gray-900">All</p>
                                <p className="text-2xl font-bold text-gray-900">{ticketCounts.all || 0}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Simplified Filters */}
                <div className="bg-white rounded-lg shadow-sm border p-4 mb-6 flex-shrink-0">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-medium text-gray-900">Filters</h3>
                        {filters.status && (
    <button
        onClick={() => {
            setFilters(prev => ({ ...prev, status: '' }));
            navigate('/tickets', { replace: true });
            fetchUserTicketsWithStatus('');
        }}
        className="flex items-center px-3 py-1 text-sm text-gray-600 hover:text-gray-800 bg-gray-100 rounded-md"
    >
        Clear Status Filter
    </button>
)}
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {/* Date Range */}
                        <div className="flex items-center space-x-2">
                            <Calendar className="w-4 h-4 text-gray-400" />
                            <input
                                type="date"
                                value={filters.dateFrom}
                                onChange={(e) => handleFilterChange('dateFrom', e.target.value)}
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <span className="text-gray-500">to</span>
                            <input
                                type="date"
                                value={filters.dateTo}
                                onChange={(e) => handleFilterChange('dateTo', e.target.value)}
                                className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Order ID Search */}
                        <input
                            type="text"
                            placeholder="Search by order id"
                            value={filters.orderId}
                            onChange={(e) => handleFilterChange('orderId', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />

                        {/* Apply/Clear Buttons */}
                        <div className="flex space-x-2">
                            <button
                                onClick={clearFilters}
                                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 text-sm"
                            >
                                Clear
                            </button>
                            <button
                                onClick={applyFilters}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm"
                            >
                                Apply Filters
                            </button>
                        </div>
                    </div>
                </div>

                {/* Tickets Table */}
                <div className="bg-white rounded-lg shadow-sm border overflow-hidden flex-1 flex flex-col min-h-0">
                    {loading ? (
                        <div className="p-8 text-center">
                            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                            <p className="mt-2 text-gray-500">Loading tickets...</p>
                        </div>
                    ) : tickets.length === 0 ? (
                        <div className="p-8 text-center">
                            <MessageSquare className="w-12 h-12 text-gray-400 mx-auto mb-3" />
                            <p className="text-gray-500 mb-2">No tickets found</p>
                            <p className="text-sm text-gray-400">Create your first support ticket to get started</p>
                        </div>
                    ) : (
                        <div className="flex-1 overflow-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50 sticky top-0">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Ticket ID
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Category/Message
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Unitee Id
                                        </th>                                                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Store Id
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Status
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Created At
                                        </th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {tickets.map((ticket) => (
                                        <tr key={ticket.ticketId} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {ticket.ticketId}
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="text-sm font-medium text-gray-900">{ticket.category}</div>
                                                <div className="text-sm text-gray-500 max-w-xs truncate">{ticket.comment}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="text-sm text-gray-900">
                                                    <div className="flex flex-col">
                                                        <span className="ml-1">{ticket.orderIdOrAwb}</span>
                                                        
                                                        {/* <button
                                                            onClick={() => copyToClipboard(ticket.orderIdOrAwb)}
                                                            className="ml-2 p-1 hover:bg-gray-100 rounded"
                                                        >
                                                            <Copy className="w-3 h-3 text-gray-400" />
                                                        </button> */}
                                                    </div>
                                                    {ticket.awb && (
                                                        <div className="flex items-center mt-1">
                                                            <span className="font-medium text-blue-600">AWB:</span>
                                                            <span className="ml-1 text-blue-600">{ticket.awb}</span>
                                                            <button
                                                                onClick={() => copyToClipboard(ticket.awb)}
                                                                className="ml-2 p-1 hover:bg-gray-100 rounded"
                                                            >
                                                                <Copy className="w-3 h-3 text-blue-400" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>

                                         <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`text-sm text-gray-900`}>
                                                    {ticket.Storeorder_id}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${statusColors[ticket.status] || 'bg-gray-100 text-gray-800'}`}>
                                                    {ticket.status?.charAt(0).toUpperCase() + ticket.status?.slice(1)}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {formatDate(ticket.createdAt)}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                {ticket.status === 'pending' || ticket.status === 'in-progress' ? (
                                                    <button 
                                                        onClick={() => openChatModal(ticket, false)}
                                                        className="relative flex items-center px-4 py-2 text-white-600 border border-blue-600 rounded-md hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                                    >
                                                        <MessageSquare className="w-4 h-4 mr-1" />
                                                        Chat
                                                        {notifications.unreadTickets.includes(ticket.ticketId) && (
                                                            <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center animate-pulse">
                                                                !
                                                            </span>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <button 
                                                        onClick={() => openChatModal(ticket, true)}
                                                        className="flex items-center px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 hover:text-gray-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
                                                    >
                                                        <Eye className="w-4 h-4 mr-1" />
                                                        View
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

    
                    <div className="bg-white px-6 py-3 border-t border-gray-200 flex items-center justify-between mt-2 rounded-lg shadow-sm">
                        <div className="text-sm text-gray-700">
                            Showing {Math.max((pagination.page - 1) * pagination.limit + 1, 1)} to{' '}
                            {Math.min(pagination.page * pagination.limit, pagination.total)} of{' '}
                            {pagination.total} results
                        </div>
                        <div className="flex space-x-2">
                            <button
                                onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                                disabled={pagination.page <= 1}
                                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Previous
                            </button>
                            
                            {/* Add page numbers */}
                            <div className="flex space-x-1">
                                {Array.from({ length: Math.min(5, pagination.pages) }, (_, i) => {
                                    let pageNum;
                                    if (pagination.pages <= 5) {
                                        pageNum = i + 1;
                                    } else if (pagination.page <= 3) {
                                        pageNum = i + 1;
                                    } else if (pagination.page >= pagination.pages - 2) {
                                        pageNum = pagination.pages - 4 + i;
                                    } else {
                                        pageNum = pagination.page - 2 + i;
                                    }
                                    
                                    return (
                                        <button
                                            key={pageNum}
                                            onClick={() => setPagination(prev => ({ ...prev, page: pageNum }))}
                                            className={`px-3 py-1 text-sm border rounded ${
                                                pagination.page === pageNum
                                                    ? 'bg-blue-500 text-white border-blue-500'
                                                    : 'border-gray-300 hover:bg-gray-50'
                                            }`}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                })}
                            </div>
                            
                            <button
                                onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                                disabled={pagination.page >= pagination.pages}
                                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Next
                            </button>
                        </div>
                    </div>
            

                            
                {/* Raise Ticket Modal */}
                <RaiseTicketModal
                    isOpen={isRaiseTicketOpen}
                    onClose={() => setIsRaiseTicketOpen(false)}
                    orderId=""
                    brandId=""
                    brandName=""
                />

                {chatModal.isOpen && (
                    <ChatModal
                        ticket={chatModal.ticket}
                        isViewOnly={chatModal.isViewOnly}
                        onClose={() => setChatModal({ isOpen: false, ticket: null, isViewOnly: false })}
                        userType="user"
                    />
                )}
            </div>
        </div>
    </div>
);
};

export default UserTickets;